import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { GetWalletsRequestQuery } from "@syla/shared/types/requests/GetWalletsRequest";
import { GetWalletsResponse } from "@syla/shared/types/responses/GetWalletsResponse";
import axios from "axios";
import { parseAssetHolding } from "../../helper/wallet/parseAssetHolding";
import { parseWallet } from "../../helper/wallet/parseWallet";

export async function getWallets(
  accountId: string,
  props: GetWalletsRequestQuery = {},
): Promise<GetWalletsResponse> {
  const { data }: { data: TransportType<GetWalletsResponse> } = await axios.get(
    `accounts/${accountId}/wallets`,
    {
      params: props,
    },
  );

  // convert api returned Decimal string to Decimal
  return {
    accountHoldings: data.accountHoldings.map(parseAssetHolding),
    wallets: data.wallets
      .filter((wallet) => {
        if (!wallet.dataSource)
          console.error(`Missing datasource for wallet ${wallet._id}`);
        return !!wallet.dataSource;
      })
      .map(parseWallet),
    missingHoldings: data.missingHoldings.map(parseAssetHolding),
  };
}
